document.body.addEventListener('variant:change:rebuilt', (e) => {
  const variantId = String(e.detail.variant.id);
  const el = document.getElementById('variant-preorder-data');
  if (!el) return;

  const preorderVal = el.getAttribute('data-preorder-release-info-' + variantId) || '';
  const tier1Val = el.getAttribute('data-tier1-ship-date-' + variantId) || '';
  const tier1Active = el.getAttribute('data-tier1-threshold-passed-' + variantId) === 'true';

  let displayVal = '';

  if (preorderVal) {
    displayVal = preorderVal;
  } else if (tier1Active && tier1Val) {
    displayVal = tier1Val;
  }

  const input = document.querySelector('input.expected-ship-by');

  if (input) {
    input.value = displayVal;
    input.disabled = !displayVal;
  }

  const $desc = jQuery('.expected-ship-description');

  if (displayVal !== '') {
    $desc.html('<p>Expected to ship by &mdash; ' + displayVal + '</p>');
    $desc.addClass('active');
  } else {
    $desc.removeClass('active');
  }
});

// 2026.6-22 BEGIN < this was added to fix BUY NOW button not appearing if initial variant on pageload was OOS.
document.body.addEventListener('variant:change:rebuilt', (e) => {
  const variant = e.detail?.variant;
  const buyButtonWrapper = document.querySelector('.buy-button-wrapper');
  if (!buyButtonWrapper) return;

  buyButtonWrapper.style.display = (variant && variant.available) ? '' : 'none';
});
// 2026.6-22 END > delete if this breaks add to cart or buy button. also additions to buy-buttons.liquid to fix same issue.

(() => {
  // Build: color -> Set(allowed sizes)
  const buildMap = () => {
    const m = new Map();
    document.querySelectorAll('#all-variants-data .variant-data').forEach(el => {
      const c = el.dataset.color?.trim();
      const s = el.dataset.size?.trim();
      if (!c || !s) return;
      if (!m.has(c)) m.set(c, new Set());
      m.get(c).add(s);
    });
    return m;
  };

  const getCtx = () => {
    const info = document.querySelector('product-info[data-section][data-url]');
    const id   = info?.dataset.section;
    const root = info?.closest('section[id^="MainProduct-"], [data-section]') || document;
    const sizeRoot = id ? (root.querySelector(`#SizeOptions-${CSS.escape(id)}`) || root) : root;
    return { id, root: sizeRoot };
  };

  const VAR = {
    map: buildMap(),
    sizeInputsSel: 'input[name="options[Size]"], input[name="Size"]',
    sizeSelectSel: 'select[name="options[Size]"]',
  };

  const getSelectedColor = (fallbackVariant) =>
    document.querySelector('input[name="Color"]:checked')?.value
    || document.querySelector('[data-option-name="Color"].is-selected')?.dataset.value
    || fallbackVariant?.option1
    || null;

  const applyForColor = (color, fallbackVariant) => {
    const { root } = getCtx();
    if (!color || !root) return;

    const allowed = VAR.map.get(color) || new Set();

    // Radios/buttons
    const sizeInputs = [...root.querySelectorAll(VAR.sizeInputsSel)];
    sizeInputs.forEach(inp => {
      const ok = allowed.has(inp.value);
      const label = document.querySelector(`label[for="${inp.id}"]`);
      inp.disabled = !ok;
      if (label) label.style.display = ok ? '' : 'none'; // or toggle a class if you prefer
    });

    // If checked is now invalid, select the first allowed and fire change
    const checked = sizeInputs.find(i => i.checked);
    const firstAllowedInput = sizeInputs.find(i => !i.disabled && allowed.has(i.value));

    if (firstAllowedInput && (!checked || checked.disabled || !allowed.has(checked.value))) {
      if (checked) checked.checked = false;
      firstAllowedInput.checked = true;
      firstAllowedInput.dispatchEvent(new Event('change', { bubbles: true }));
      // console.log('[sizesimple] auto-selected radio size:', firstAllowedInput.value);
    }

    // Dropdown fallback (if theme uses a select)
    const sel = root.querySelector(VAR.sizeSelectSel);
    if (sel) {
      [...sel.options].forEach(opt => {
        const ok = allowed.has(opt.value);
        opt.disabled = !ok;
        opt.hidden   = !ok;
      });
      if (!allowed.has(sel.value)) {
        const first = [...sel.options].find(o => !o.disabled && !o.hidden);
        if (first) {
          sel.value = first.value;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
          // console.log('[sizesimple] auto-selected select size:', first.value);
        }
      }
    }
  };

  // Initial run
  document.addEventListener('DOMContentLoaded', () => {
    applyForColor(getSelectedColor());
  });

  // Update on your existing event
  document.body.addEventListener('variant:change:rebuilt', (e) => {
    const color = getSelectedColor(e.detail?.variant);
    applyForColor(color, e.detail?.variant);
  });
})();

// Ensure a valid size is selected BEFORE the theme's variant handler runs
(() => {
  // Parse variants once
  const getVariants = (() => {
    let cache = null;
    return () => {
      if (cache) return cache;
      const node =
        document.querySelector('variant-radios script[type="application/json"]') ||
        document.querySelector('variant-selects script[type="application/json"]');
      try { cache = node ? JSON.parse(node.textContent) : []; } catch { cache = []; }
      if (Array.isArray(cache)) return cache;
      if (cache && Array.isArray(cache.variants)) return (cache = cache.variants);
      return (cache = []);
    };
  })();

  // Does a color+size combo exist as a real variant?
  const hasVariant = (color, size) =>
    !!getVariants().find(v => v.option1 === color && v.option2 === size);

  // Pick the first size that forms a real variant with this color
  const pickFirstValidSize = (color, scope) => {
    const inputs = [...scope.querySelectorAll('input[name="options[Size]"], input[name="Size"]')];
    for (const i of inputs) {
      const val = (i.value || '').trim();
      const lbl = scope.querySelector(`label[for="${i.id}"]`);
      const visible = lbl ? lbl.style.display !== 'none' : true; // respects your hide logic
      if (!i.disabled && visible && hasVariant(color, val)) {
        // Click label so theme updates classes/state
        lbl ? lbl.click() : (i.checked = true, i.dispatchEvent(new Event('change', { bubbles: true })));
        return true;
      }
    }
    return false;
  };

  // Find the current product section scope
  const getScope = () => {
    const info = document.querySelector('product-info[data-section][data-url]');
    if (!info) return document;
    const sectionId = info.dataset.section;
    const root = info.closest('section[id^="MainProduct-"], [data-section]') || document;
    return root.querySelector(`#SizeOptions-${CSS.escape(sectionId)}`) || root;
  };

  // Run FIRST (capture=true) on color changes
  document.addEventListener('change', (e) => {
    const t = e.target;
    if (!(t instanceof HTMLInputElement)) return;
    if (t.name !== 'Color') return;

    const color = t.value;
    const scope = getScope();

    // If current size would create a non-existent variant, switch to a valid size now
    const checked = scope.querySelector('input[name="options[Size]"]:checked, input[name="Size"]:checked');
    const curSize = (checked?.value || '').trim();
    if (!hasVariant(color, curSize)) {
      pickFirstValidSize(color, scope);
      // no preventDefault: let the theme proceed now that size is valid
    }
  }, true); // 👈 capture phase so we run before VariantRadios
})();

(() => {
  // put the order you want here
  const ORDER = ["5", "5.5","6","6.5","7","7.5","8","8.5","9","9.5","10","10.5","11","11.5","12","12.5"];
  const rank = new Map(ORDER.map((v,i) => [v, i]));

  const sortSizes = () => {
    // fieldset has class "Size" in your markup
    const fs = document.querySelector('fieldset.Size');
    if (!fs) return;

    const items = [...fs.querySelectorAll('input[name="Size"]')].map(inp => {
      const id = inp.id;
      const label = fs.querySelector(`label[for="${CSS.escape(id)}"]`);
      return { inp, label, r: rank.has(inp.value) ? rank.get(inp.value) : 999 };
    }).sort((a,b) => a.r - b.r);

    // re-append in desired order (keeps current theme styles/classes)
    items.forEach(({ inp, label }) => {
      fs.appendChild(inp);
      if (label) fs.appendChild(label);
    });
  };

  document.addEventListener('DOMContentLoaded', sortSizes);
  document.body.addEventListener('variant:change:rebuilt', sortSizes);
})();



